import type { LifecycleAdapter, SafeAreaInsets } from '../types';

export const webLifecycle: LifecycleAdapter = {
  onVisibilityChange(cb) {
    const handler = () => cb(document.visibilityState === 'visible');
    document.addEventListener('visibilitychange', handler);
    return () => document.removeEventListener('visibilitychange', handler);
  },
  onResize(el, cb) {
    const ro = new ResizeObserver(entries => {
      for (const e of entries) cb(e.contentRect);
    });
    ro.observe(el);
    return () => ro.disconnect();
  },
  safeArea(): SafeAreaInsets {
    // env() can't be read directly via getPropertyValue — it's a CSS function,
    // not a custom property. We declare CSS vars in index.css that wrap env(),
    // and read those resolved values here.
    const s = getComputedStyle(document.documentElement);
    const v = (prop: string) => parseFloat(s.getPropertyValue(prop)) || 0;
    return {
      top:    v('--safe-area-top'),
      right:  v('--safe-area-right'),
      bottom: v('--safe-area-bottom'),
      left:   v('--safe-area-left'),
    };
  },
  prefersReducedMotion() {
    return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
  },
  setThemeColor(color) {
    document.body.style.background = color;
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', color);
  },
};
